import { Expandable } from "./../../../js/Expandable";
import { trapFocus } from "./../../../js/SvelteActions";

export class ModalManager {
    constructor($block, focusPointsSelector) {
        this.$block = $block
        this.focusPointsSelector = focusPointsSelector
        
        this.$container = this.$block.querySelector('[data-hotspots-modal-container]')
        this.regionsIDs = []
        this.currentIndex = undefined // this.regions.indexOf(this.currentId), // -1
        this.currentID = 'idle'
        this.$prevBtn = this.$block.querySelector('[data-hotspots-modal-prev]')
        this.$nextBtn = this.$block.querySelector('[data-hotspots-modal-next]')
        this.$closeBtn = this.$block.querySelector('[data-hotspots-modal-close]')
        
        this.initAccordions()
        this.initFocusPoints()
        // this.initButtons()
    }
    initAccordions() {
        this.$block.querySelectorAll('.accordion-region').forEach($region => new Expandable($region, {
            on: {
                close: function(region) {
                    region.setAttribute('inert', 'inert')
                },
                open: function(region) {
                    region.removeAttribute('inert')
                }
            }
        }))
    }
    initFocusPoints() {
        this.$block.querySelectorAll(this.focusPointsSelector).forEach($dot => {
            // register IDs
            if ($dot.dataset.name !== 'idle') this.regionsIDs.push($dot.dataset.name)
        })
        // console.log('ModalManager.regionsIDs', this.regionsIDs)
    
        // console.log(this)
    }
    close() {
        // console.log('ModalManager.close()')
        this.$container.dataset.hidden = 'true'
        this.$block.dataset.modalState = 'closed'
        
        const id = this.regionsIDs.at(this.currentIndex)
        this.$container.querySelector(`#${id}`).expandable.close()
        
        this.currentID = 'idle'
        this.trapFocus = this.trapFocus?.destroy()
    }
    prev() {
        // console.log('ModalManager.prev()')
        if (this.currentIndex === 0) return
        // else
        this.currentIndex -= 1
        this.open(this.regionsIDs.at(this.currentIndex))
        
        // this.$block.querySelector(`[data-focus-point][data-name="${this.regionsIDs.at(this.currentIndex - 1)}"]`).click()
    }
    next() {
        // console.log('ModalManager.next()')
        if (this.currentIndex === this.regionsIDs.length - 1) return
        // else
        this.currentIndex += 1
        this.open(this.regionsIDs.at(this.currentIndex))
        
        // this.$block.querySelector(`[data-focus-point][data-name="${this.regionsIDs.at(this.currentIndex + 1)}"]`).click()
    }
    open(id) {
        // console.log(`ModalManager.open('${id}')`)
        this.currentID = id
        this.currentIndex = this.regionsIDs.indexOf(id)
        
        this.$container.dataset.hidden = 'false'
        this.$block.dataset.modalState = 'open'
        
        this.$container.querySelector(`#${id}`).expandable.open()
        
        this.$prevBtn.disabled = this.currentIndex === 0
        this.$nextBtn.disabled = this.currentIndex === this.regionsIDs.length - 1
        
        this.trapFocus = trapFocus(this.$container) // TODO: improve trapFocus ; manage PROPERLY when prev or next are disabled + we want to keep focus on "next" after clicking it
    }
}